import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const editCurrency = (payload) => async (dispatch) => {
  dispatch({ type: "EDIT_CURRENCY_REQUEST" });
  try {
    const { data } = await axios.post(
      `${BASE_URL}/setting/update`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (data.statusCode === 200) {
      dispatch({ type: "EDIT_CURRENCY_SUCCESS", payload: data });
      return { success: true };
    } else {
      dispatch({ type: "EDIT_CURRENCY_FAILURE", payload: data });
      return { success: false };
    }
  } catch (error) {
    dispatch({ type: "EDIT_CURRENCY_FAILURE", payload: error.response || error.message });
    return { success: false };
  }
};


export const getCurrency = (showLoader = true) => async (dispatch) => {
  if(showLoader) {
    dispatch({ type: "FETCH_CURRENCY_REQUEST" });
  }
  try {
    const { data } = await axios.get(`${BASE_URL}/setting/view`, { headers: { "Content-Type": "application/json" } });
    if(data.statusCode === 200){
      dispatch({ type: "FETCH_CURRENCY_SUCCESS", payload: data });
      return { success: true, data };
    } else {
      dispatch({ type: "FETCH_CURRENCY_FAILURE", payload: data });
      return { success: false };
    }
  } catch(error) {
    dispatch({ type: "FETCH_CURRENCY_FAILURE", payload: error.response || error.message });
    return { success: false };
  }
};

